


































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Model, Emit, Ref, Prop } from "vue-property-decorator";
import {
  AddressInputGroup,
  DateInput,
  FactorLevelInput
} from "@/components/inputs";
import DoctorSelector from '@/components/DoctorSelector.vue';
import { auth as authStore, doctor as store } from "@/store/modules";
import { required, phoneNoRules, weightRules, inhibitorUnitRules, emailRules } from "@/utils/validation";
import { Address } from "cluster";
import { PatientModel, TreatmentMethod, FactorActivity, TargetJoints, TargetJointTypes, MovementActivity, RealFactorActivity } from "@/models/patient";
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import { inject } from 'inversify-props';
import { IPatientService, ConstantDescriber, IDoctorService, IDrugGroupService } from '@/interfaces/Services';
import { deepOverwrite } from '@/utils/transformers';
import { DoctorModel } from '@/models/doctor';
import { DrugGroupModel } from '@/models/drug_group';
import { auth } from "@/store/modules";
import { id } from "inversify";

@Component({
  components: {
    AddressInputGroup,
    DateInput,
    FactorLevelInput,
    DoctorSelector
  }
} as any)
class PatientEditor extends Vue {
  @inject(DependencyIdentifiers.PatientService)
  private patientService!: IPatientService;
  @inject(DependencyIdentifiers.DoctorService)
  private doctorService!: IDoctorService;
  @inject(DependencyIdentifiers.DrugGroupService)
  private drugGroupService!: IDrugGroupService;

  @Ref()
  form: any;

  snackbar = {
    isVisible: false,
    color: 'info',
    timeout: 4000,
    text: ''
  }

  private doctors: DoctorModel[] = [];
  private drugGroups: DrugGroupModel[] = [];
  public newFactorActivities: RealFactorActivity[] = [];
  public factorActivitiesAvailable = [
    {
      value: 'willebrand',
      label: 'Willebrand',
      disabled: false,
    },
    {
      value: 'v',
      label: 'V',
      disabled: false,
    },
    {
      value: 'vii',
      label: 'VII',
      disabled: false,
    },
    {
      value: 'ix',
      label: 'IX',
      disabled: false,
    },
    {
      value: 'x',
      label: 'X',
      disabled: false,
    },
    {
      value: 'xiii',
      label: 'XIII',
      disabled: false,
    },
  ];

  get formConfig() {
    return {
      email: {
        label: this.$t('patient.fields.email') + '*',
        rules: [required, ...emailRules]
      },
      name: {
        label: this.$t('patient.fields.name') + '*',
        rules: [required]
      },
      phoneNo: {
        label: this.$t('patient.fields.phoneNo'),
        prefix: "+36",
        rules: [...phoneNoRules]
      },
      socialSecurityNo: {
        label: this.$t('patient.fields.socialSecurityNo') + '*',
        rules: [
          required,
          (v: string) =>
            v.replace(/^[d]/, "").length === 9 || this.$t('validator.invalidValue')
        ]
      },
      address: {
        label: this.$t('patient.fields.address'),
        optional: true
      },
      temporaryAddress: {
        label: this.$t('patient.fields.temporaryAddress'),
        optional: true
      },
      $doctorId: {
        label: this.$t('patient.fields.dealingPhysician') + '*',
        items: Object.values(this.doctors),
        rules: [required]
      },
      $factorConcentrateApplied: {
        label: this.$t('patient.fields.factorConcentrateApplied'),
        items: Object.values(this.drugGroups).sort((a, b) => a.brandName.localeCompare(b.brandName)),
        rules: [],
      },
      treatmentMeta: {
        weight: {
          label: this.$t('patient.fields.weight'),
          prefix: "kg",
          rules: [...weightRules, required]
        },
        inhibitorUnit: {
          label: this.$t('patient.fields.inhibitorUnit'),
          prefix: "BE/ml",
          rules: [...inhibitorUnitRules]
        },
        associatedDiseaseConditions: {
          label: this.$t('patient.fields.associatedDiseaseConditions'),
          items: this.consts.patient.associated_disease_condition
        },
        birthdate: {
          label: this.$t('patient.fields.birthdate') + '*',
          rules: [required]
        },
        bloodType: {
          label: this.$t('patient.fields.bloodType') + '*',
          items: this.consts.patient.blood_type,
          rules: [required],
        },
        concomittantMedication: {
          label: this.$t('patient.fields.concomittantMedication')
        },
        diagnosis: {
          label: this.$t('patient.fields.diagnosis')
        },
        drugAllergy: {
          label: this.$t('patient.fields.drugAllergy')
        },
        additionalDiseaseConditions: {
          label: this.$t('patient.fields.additionalDiseaseConditions'),
        },
        factorActivity: {
          label: this.$t('patient.fields.factorActivity') + '*',
          items: this.consts.patient.factor_activity,
          rules: [
            (val: FactorActivity[]) =>  val.length > 0 || this.$t('validator.required')
          ]
        },
        factorLevel: {
          label: this.$t('patient.fields.factorLevel.label')
        },
        inhibitor: {
          label: this.$t('patient.fields.inhibitor')
        },
        irregularAntibodies: {
          label: this.$t('patient.fields.irregularAntibodies')
        },
        methodOfTreatment: {
          label: this.$t('patient.fields.methodOfTreatment') + '*',
          items: this.consts.patient.treatment_method,
          rules: [required]
        },
        walkingAid: {
          label: this.$t('patient.fields.walkingAid')
        },
        targetJoints: {
          label: this.$t('patient.fields.targetJoints'),
          items: this.consts.patient.target_joints,
          rules: [required]
        },
        targetJointTypes: {
          label: this.$t('patient.fields.targetJointTypes'),
          items: this.consts.patient.target_joint_types,
          rules: [required]
        },
        otherTargetJoint: {
          label: this.$t('patient.fields.otherTargetJoint')
        },
        movementActivity: {
          label: this.$t('patient.fields.movementActivity'),
          items: this.consts.patient.movement_activity,
          rules: [required]
        },
      }
    };
  }

  formData: PatientModel = {
    $doctorId: null,
    $centerId: null,
    email: "",
    name: "",
    phoneNo: "",
    socialSecurityNo: "",
    address: null,
    temporaryAddress: null,
    $factorConcentrateApplied: [],
    treatmentMeta: {
      weight: undefined,
      associatedDiseaseConditions: [],
      additionalDiseaseConditions: '',
      birthdate: undefined,
      bloodType: undefined,
      concomittantMedication: "",
      diagnosis: "",
      drugAllergy: "",
      factorActivities: [],
      inhibitor: false,
      inhibitorUnit: undefined,
      irregularAntibodies: false,
      methodOfTreatment: TreatmentMethod.Profilaxis,
      targetJoints: TargetJoints.None,
      targetJointTypes: [],
      otherTargetJoint: "",
      movementActivity: MovementActivity.None,
      walkingAid: false,
    }
  };

  isLoading = false;
  isNotFound = false;
  hideOtherJoint = true;
  private consts!: ConstantDescriber;

  @Emit("cancel")
  onCancel() {
    if (window.history.length) {
      this.$router.back();
    } else {
      this.$router.push({ path: '/dashboard/patients' });
    }
  }

  @Emit("created")
  onCreated(model: PatientModel) {
    return model;
  }

  @Emit("updated")
  onUpdated(model: PatientModel) {
    return model;
  }

  @Emit("save")
  onSave(model: PatientModel) {
    return model;
  }

  changeTargetJointTypes(value: TargetJointTypes[]) {
    if (value.includes(TargetJointTypes.OtherJoint)) {
      this.hideOtherJoint = false;
    } else {
      this.hideOtherJoint = true;
    }
    this.onChange(value);
  }

  @Emit('changeTargetJointTypes')
  onChange(value: TargetJointTypes[]) { return value; }

  checkAvailableFactors(factorType: string) {
    const idx = this.factorActivitiesAvailable.findIndex(f => f.value === factorType);
    this.factorActivitiesAvailable[idx].disabled = !this.factorActivitiesAvailable[idx].disabled;
  }

  @Emit("remove")
  remove(index: number) {
    const factorType = this.newFactorActivities[index].factor;
    this.newFactorActivities.splice(index, 1);
    this.checkAvailableFactors(factorType);
  }

  enumFromValue = <T extends Record<string, string>>(val: string, _enum: T) => {
    const enumName = (Object.keys(_enum) as Array<keyof T>).find(k => _enum[k] === val)
    if (!enumName) throw Error()
    return _enum[enumName]
  }

  @Emit("add")
  add() {
    let available: {value: string, label: string, disabled: boolean} | undefined;
    if (this.factorActivitiesAvailable !== undefined && this.factorActivitiesAvailable.length > 0) {
      available = this.factorActivitiesAvailable.find(e => e.disabled === false);
    }
    if (available !== undefined) {
      const factorType = this.enumFromValue(available.value, FactorActivity);
      this.newFactorActivities.push({
        factor: factorType,
        op: "eq",
        value: 0
      });
      this.checkAvailableFactors(factorType);
    }
  }

  changeFactor(factorType: any) {
    this.checkAvailableFactors(factorType);
    for (let i = 0; i < this.factorActivitiesAvailable.length; i++) {
      const idx = this.newFactorActivities.findIndex(f => f.factor === this.factorActivitiesAvailable[i].value);
      if (idx === -1) {
        this.factorActivitiesAvailable[i].disabled = false;
      }
    }
    return factorType;
  }

  @Model("change")
  value!: string;

  @Prop()
  id?: string;

  @Prop({ default: '', required: false })
  showRemove!: boolean;

  @Prop({ default: '', required: false })
  showCancel!: boolean;

  created() {
    this.consts = (this as any).apiConstants;
  }

  async mounted() {
    this.formData.address = null;
    this.formData.temporaryAddress = null;
    try {
      await this.loadDoctors();
      await this.loadDrugGroups();
      await this.fetchPatient();
    } catch (e) {
      this.isLoading = false;
      this.isNotFound = true;
      console.log(e);
    }
  }

  private async loadDoctors() {
    try {
      const page = 1,
        itemsPerPage = 100;
      const [doctors, {}] = await this.doctorService.getMany(
        page,
        itemsPerPage
      );
      this.doctors = [...doctors];
    } finally {
      this.isLoading = false;
    }
  }

  private async loadDrugGroups() {
    try {
      const page = 1,
        itemsPerPage = 100;
      const [drugGroups, {}] = await this.drugGroupService.getMany(
        page,
        itemsPerPage
      );
      this.drugGroups = [...drugGroups];
    } finally {
      this.isLoading = false;
    }
  }

  async fetchPatient() {
    if (!this.id) {
      return;
    }
    this.isLoading = true;
    try {
      const patient = await this.patientService.getById(this.id);
      this.formData = deepOverwrite(this.formData, patient);

      // Deep overwrite fucks up the array, I don't have the patient to fix it.
      // Here's my dirty fix
      const adc = patient.treatmentMeta.associatedDiseaseConditions;
      this.formData.treatmentMeta.associatedDiseaseConditions
        = typeof adc === 'string' ? [adc] : adc;
      this.formData.treatmentMeta.factorActivities = patient.treatmentMeta.factorActivities || [];
      this.formData.$factorConcentrateApplied = patient.$factorConcentrateApplied;
      this.formData.treatmentMeta.additionalDiseaseConditions
        = this.formData.treatmentMeta.additionalDiseaseConditions || '';
      this.formData.treatmentMeta.targetJointTypes = patient.treatmentMeta.targetJointTypes || [];

      if (this.formData.treatmentMeta.targetJointTypes.includes(TargetJointTypes.OtherJoint)) {
        this.hideOtherJoint = false;
      }
      this.newFactorActivities = this.formData.treatmentMeta.factorActivities;
      //check what missing factors the patient have and disable them in the select
      for (const factor of this.newFactorActivities) {
        this.checkAvailableFactors(factor.factor);
      }
      this.componentKey++;
    } finally {
      this.isLoading = false;
    }
  }

  componentKey = 0;

  onDoctorIdChange(value: string) {
    this.formData.$doctorId = value;
  }

  get hasPrimaryCenter() {
    return auth.hasPrimaryCenter;
  }

  async save() {
    if (!this.form.validate()) {
      return;
    }
    this.isLoading = true;
    try {
      this.formData.$centerId = authStore.currentCenterId;

      if (this.formData.treatmentMeta.targetJointTypes)
      {
        const joints = this.formData.treatmentMeta.targetJointTypes;
        const length = joints.length;
        if (length === 0) {
          this.formData.treatmentMeta.targetJoints = TargetJoints.None;
        } else if (length === 1) {
          this.formData.treatmentMeta.targetJoints = TargetJoints.One;
        } else {
          this.formData.treatmentMeta.targetJoints = TargetJoints.Multiple;
        }

        if (!joints.includes(TargetJointTypes.OtherJoint)) {
          this.formData.treatmentMeta.otherTargetJoint = "";
        }
      }

      this.formData.treatmentMeta.factorActivities = this.newFactorActivities;

      this.onSave(await this.upsert(this.id, this.formData));
    } catch(e) {
      this.snackbar.isVisible = true;
      this.snackbar.text = this.$t('general.unknownErrorOccurredCheckForm') as string;
      this.snackbar.color = 'error';
    } finally {
      this.isLoading = false;
    }
  }

  private async upsert(id: any, data: PatientModel) {
    let model: PatientModel;
    if (!data.treatmentMeta.inhibitor) {
      data.treatmentMeta.inhibitorUnit = 0;
    }
    data.treatmentMeta.factorActivities = this.newFactorActivities;
    if (id) {
      model = await this.patientService.updateById(id, data);
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.onUpdated(model);
    } else {
      model = await this.patientService.create(data);
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.onCreated(model);
    }
    return model;
  }
}
export default PatientEditor;
